import { createRoute } from 'framework/routing';

export const PROJECTS_COMPLIACNE = '/projects-compliance';

// permissions
export const PROJECTS_COMPLIANCE_LIST = 'DELIVERY_COMPLIANCE_READ_LIST';

export const useProjectsComplianceRoute = () => {
  const routes = createRoute({ listRoute: PROJECTS_COMPLIACNE });

  return routes;
};
